export default __webpack_public_path__ + "static/media/BombaFull.d776ec94.png";